import type { Socket } from 'socket.io-client';
import type { UserProfile } from '../hooks/useProfile';

export interface ProfileState { profile: UserProfile | null; isLoading: boolean; error: string | null }

// One subscription per confirmed socket identity. Old responses cannot populate a new account.
export function observeProfile(socket: Pick<Socket, 'on' | 'off' | 'emit'>, playerId: string, update: (state: ProfileState) => void) {
  let profile: UserProfile | null = null;
  let timer: ReturnType<typeof setTimeout>;
  const fetchProfile = () => {
    clearTimeout(timer);
    update({ profile, isLoading: true, error: null });
    timer = setTimeout(() => update({ profile, isLoading: false, error: 'Profil non reçu. Réessayez.' }), 12000);
    socket.emit('player:getProfile');
  };
  const receive = (data: { player: { id: string } | null; profile: UserProfile | null }) => {
    if (data.player && data.player.id !== playerId) return;
    clearTimeout(timer);
    profile = data.profile;
    update({ profile, isLoading: false, error: profile ? null : 'Profil indisponible. Réessayez.' });
  };
  const committed = () => fetchProfile();
  socket.on('player:profile', receive);
  socket.on('profile:updated', committed);
  fetchProfile();
  return { fetchProfile, dispose: () => {
    clearTimeout(timer);
    socket.off('player:profile', receive);
    socket.off('profile:updated', committed);
  } };
}
